// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{--mobile-nav-height: calc(58px + max(calc(env(safe-area-inset-bottom) - 15px), 0px))}#mobile-nav{contain:strict;display:none}@media(max-width: 768px){#content-vue>.app-navigation{display:none}#mobile-nav{display:flex}#app-content-vue>.router-outlet.has-nav{height:calc(100% - var(--mobile-nav-height))}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
